import { render, staticRenderFns } from "./QuoteSVG.vue?vue&type=template&id=e2365e2c&"
import script from "./QuoteSVG.vue?vue&type=script&lang=js&"
export * from "./QuoteSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports